import { render, staticRenderFns } from "./SideBar.html?vue&type=template&id=41a5bc9f&scoped=true&"
import script from "./SideBar.js?vue&type=script&lang=js&"
export * from "./SideBar.js?vue&type=script&lang=js&"
import style0 from "./SideBar.scss?vue&type=style&index=0&id=41a5bc9f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41a5bc9f",
  null
  
)

export default component.exports